import cn from "classnames"
import { Fragment } from "react"

import { Choices } from "modules/NewClientSurvey/common"
import { List } from "modules/NewClientSurvey/components/MultiSelect/components/List"
import style from "modules/NewClientSurvey/components/MultiSelect/style.module.scss"

interface Pros {
    className?: string
    questionId: string
    title?: string
    choices: Choices[]
    prompt?: string
    onClickItem: (questionId: string, choice: Choices) => void
}

export function MultiSelect({ className, questionId, title, choices, prompt, onClickItem }: Pros) {
    const hasChildrenChoices = choices.some((item) => item.choices)

    return (
        <div className={cn(style.container, className)}>
            {title && <div className={style.title}>{title}</div>}
            {hasChildrenChoices ? (
                <div className={style.list}>
                    {choices.map((item) => {
                        return (
                            <Fragment key={item.id}>
                                {item.choices ? (
                                    <List
                                        questionId={questionId}
                                        title={item.title}
                                        choices={item.choices}
                                        onClickItem={(choice) => onClickItem(questionId, choice)}
                                    />
                                ) : null}
                            </Fragment>
                        )
                    })}
                </div>
            ) : (
                <List
                    questionId={questionId}
                    choices={choices}
                    onClickItem={(choice) => onClickItem(questionId, choice)}
                />
            )}
            {prompt && <div className={style.prompt}>{prompt}</div>}
        </div>
    )
}
